module.exports = __webpack_public_path__ + "assets/images/75b26f9088591fef6d623b98083f8e26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/fpjs.svg
// module id = 789
// module chunks = 0